import { createContext } from "solid-js";
const context = createContext(null);
export default context;
